<template>
  <div class="left_sidebar">
    <div class="left_sidebar_frame">
      <el-tabs type="border-card" v-model="activeName" @tab-click="change_tab"
               v-loading="$store.state.app.save_loading">
        <el-tab-pane name="module">
          <div slot="label" class="left_sidebar_item" :class="activeName === 'module' ? 'left_module_select' : ''">
            <i class="left_module left_sidebar_icon"></i>
            <p class="left_sidebar_title">{{$t('view_left_sidebar_btn_108')}}</p>
          </div>
          <module-setting v-if="activeName === 'module'"></module-setting>
        </el-tab-pane>
        <el-tab-pane name="page" v-if="$store.state.app.role === 'designer'">
          <div slot="label" class="left_sidebar_item" :class="activeName === 'page' ? 'left_module_select' : ''">
            <i class="page left_sidebar_icon"></i>
            <p class="left_sidebar_title">{{$t('view_left_sidebar_btn_109')}}</p>
          </div>
          <page></page>
        </el-tab-pane>
        <el-tab-pane name="style">
          <div slot="label" class="left_sidebar_item" :class="activeName === 'style' ? 'left_module_select' : ''">
            <i class="style left_sidebar_icon"></i>
            <p class="left_sidebar_title">{{$t('view_left_sidebar_btn_110')}}</p>
          </div>
          <page_setting v-if="activeName === 'style'"></page_setting>
        </el-tab-pane>
        <el-tab-pane name="set">
          <div slot="label" class="left_sidebar_item" :class="activeName === 'set' ? 'left_module_select' : ''">
            <i class="set left_sidebar_icon"></i>
            <p class="left_sidebar_title">{{$t('view_public_topbar_4')}}</p>
          </div>
          <setting v-if="activeName === 'set'"></setting>
        </el-tab-pane>
      </el-tabs>
      <i class="el-icon-close btn_close" @click="dialog_close"></i>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import ModuleSetting from './module_setting'
import page_setting from "@/view/left_sidebar/page_setting/page_setting"
import page from './page'
import setting from './setting'
import Store from "../../vuex/store";

export default {
  name: "left_sidebar",
  watch: {
    '$store.state.left_sidebar.active'(val) {
      this.activeName = val
    }
  },
  data() {
    return {
      activeName: this.$store.state.left_sidebar.active
    };
  },
  components: {
    ModuleSetting,
    page_setting,
    page,
    setting
  },
  mounted() {
    //左侧框拖拽
    $('.left_sidebar').draggable({
      containment: 'window',

    });
    this.$nextTick(() => {
      this.templet.left_sidebar_draggable()
    })
  },
  methods: {
    dialog_close() {
      this.$store.commit('left_sidebar/set_dialog', false);
    },
    change_tab(tab) {
      this.$store.commit('left_sidebar/set_active', tab.name)
      this.activeName = this.$store.state.left_sidebar.active
      this.$nextTick(() => {
        this.templet.left_sidebar_draggable()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/global-variable.scss';

.left_sidebar {
  position: fixed;
  z-index: 1999;
  top: $topBar-height;
  left: 176px;
  width: 380px;
  height: calc(100% - 80px);
  max-height: 740px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, .2);
  overflow: hidden;

  .left_sidebar_frame {
    width: 100%;
    height: 100%;
  }

  .el-tabs {
    height: 100%;
    border: none;
  }

  /deep/ .el-tabs__header {
    overflow: hidden;
    width: 100%;
    height: 65px;
    font-size: 0;
    background: #3D8AFF;

    .el-tabs__item {
      display: inline-block;
      width: 80px;
      height: 65px;
      border: none !important;
      line-height: 58px;
      text-align: center;
      cursor: pointer;
      color: #94a6ea;
      font-size: 16px;

      &.is-active {
        background-color: rgba(255, 255, 255, 0.15);
        color: #ffffff;
      }

      .left_sidebar_item {
        width: 100%;
        height: 100%;
        overflow: hidden;

        .left_sidebar_icon {
          display: block;
          width: 30px;
          height: 30px;
          margin: 22px auto 5px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          transition: margin-top 0.2s;

          &.left_module {
            background-image: url("/static/image/leftbar/icon-module-white@2x.png");
          }

          &.page {
            background-image: url("/static/image/leftbar/icon-page-white@2x.png");
          }

          &.style {
            background-image: url("/static/image/leftbar/icon-style-white@2x.png");
          }

          &.set {
            background-image: url("/static/image/leftbar/icon-setting-white@2x.png");
          }
        }

        .left_sidebar_title {
          width: 100%;
          height: 14px;
          font-size: 12px;
          text-align: center;
          color: #fff;
          line-height: 14px;
          margin-top: 40px;
          transition: margin-top 0.2s;
          display: table;
        }

        &.left_module_select {
          .left_sidebar_icon {
            margin-top: 8px;
          }

          .left_sidebar_title {
            margin-top: 4px;
          }
        }
      }
    }
  }

  /deep/ .el-tabs__content {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0;
    height: calc(100% - 58px);
    .el-tab-pane:first-child{
      height: 100%;
    }
  }

  .btn_close {
    position: absolute;
    right: 0;
    top: 0;
    width: 57px;
    height: 65px;
    line-height: 65px;
    font-size: 26px;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/index.vue